module.exports = __webpack_public_path__ + "static/media/101010-house-of-yes-paradise.132d90a3.mp4";